import useToken from 'hooks/useToken';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Spinner, Card, Container } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';

import ConfirmationModal from '../facturas-emitidas/lista-facturas/ConfirmationModal';
import ModalRegistrarFacturaComoGasto from './visualizacion-factura/ModalRegistrarFacturaComoGasto';
import ConsultarEstatus from '../common/ConsultarEstatus';

// Importing reusable components from facturas-emitidas
import DatosFactura from '../facturas-emitidas/visualizacion-factura/DatosFactura';
import ConceptosFactura from '../facturas-emitidas/visualizacion-factura/ConceptosFactura';
import CondicionesPago from '../facturas-emitidas/visualizacion-factura/CondicionesPago';
import SellosDigitales from '../facturas-emitidas/visualizacion-factura/SellosDigitales';
import BotonesAccionRecibidas from './visualizacion-factura/BotonesAccionRecibidas';
import HeaderFacturaRecibida from './visualizacion-factura/HeaderFacturaRecibida';


const VisualizacionFacturasRecibidas = () => {

    const { showErrorToast, showSuccessToast } = useToast();

    const { token, setToken } = useToken();
    const { id } = useParams();

    const [cargando, setCargando] = useState(false);
    const [receptor, setReceptor] = useState({});
    const [emisor, setEmisor] = useState({});
    const [facturaElectronica, setFacturaElectronica] = useState({});
    const [datosSellos, setDatosSellos] = useState({});
    const [conceptos, setConceptos] = useState([]);
    const [total, setTotal] = useState({});
    const [value, setValue] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);
    const [isActive, setIsActive] = useState(null)
    const [idGasto, setIdGasto] = useState(null);

    const [showGastoModal, setShowGastoModal] = useState(false);



    useEffect(() => {
        ObtenerXML();
    }, [id]);

    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    };


    const ObtenerXML = async () => {
        setCargando(true)

        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        console.log("Informacion enviada al endpoint", objDataSend)
        const response = await fetch("/api/FacturasRecibidas/obtenerXMLFacturaRecibida",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            console.log("==== informacion Factura  ====");
            setCargando(false);
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            setCargando(false);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                console.log(ObjDetalles, "detalles")

                setIsActive(ObjDetalles.table2[0].bIsActive)
                setIdGasto(ObjDetalles.table2[0].idGasto || null);

                let vXMLString = ObjDetalles.table2[0].vXML;
                let vXML = JSON.parse(vXMLString);
                console.log(vXML)

                let emisorA = vXML.Comprobante.Emisor;

                let emisor = ObjDetalles.table2[0].vRegimenFiscalEmisor;

                setEmisor({ ...emisorA, ...emisor, vRegimenFiscalEmisor: emisor });
                let receptor = vXML.Comprobante.Receptor;

                let comprobante = vXML.Comprobante;



                let complemento = vXML.Comprobante.Complemento.timbreFiscalDigital;
                const tfd = vXML.Comprobante.Complemento.timbreFiscalDigital;
                const cadenaOriginal = `||${tfd.version}|${tfd.UUID}|${tfd.FechaTimbrado}|${tfd.RfcProvCertif}|${tfd.SelloCFD}|${tfd.NoCertificadoSAT}||`;




                let productos = vXML.Comprobante.Conceptos.Concepto;



                setConceptos(productos);




                /***************/
                /*Cuenta total factura*/
                /***************/

                let total = vXML.Comprobante.Total || 0;
                let subtotal = vXML.Comprobante.SubTotal || 0;

                let tasaOCuota = vXML.Comprobante.Impuestos?.Traslados?.Traslado?.[0]?.TasaOCuota || 0;
                let descuento = vXML.Comprobante.Descuento || null;



                /*let total = vXML.Comprobante.Impuestos.Traslados.Traslado[0];*/
                let traslados2 = vXML.Comprobante.Impuestos?.TotalImpuestosTrasladados || 0;
                let retenidos = vXML.Comprobante.Impuestos?.TotalImpuestosRetenidos || 0;




                /***************/
                /*TRASLADOS/
                /***************/
                let traslados = vXML.Comprobante.Impuestos?.Traslados?.Traslado;

                let TrasladoISR = 0;
                let TrasladoIVA = 0;

                if (Array.isArray(traslados)) {
                    traslados.forEach((tras) => {
                        switch (tras.Impuesto) {
                            case '001': TrasladoISR += parseFloat(tras.Importe || 0); break;
                            case '002': TrasladoIVA += parseFloat(tras.Importe || 0); break;
                        }
                    });
                } else if (traslados) {
                    switch (traslados.Impuesto) {
                        case '001': TrasladoISR += parseFloat(traslados.Importe || 0); break;
                        case '002': TrasladoIVA += parseFloat(traslados.Importe || 0); break;
                    }
                }



                /***************/
                /*RETENCIONES/
                /***************/

                let retenciones = vXML.Comprobante.Impuestos?.Retenciones?.Retencion;

                let RetencionIVA = 0;
                let RetencionISR = 0;
                let RetencionIEPS = 0;

                if (Array.isArray(retenciones)) {
                    retenciones.forEach((ret) => {
                        switch (ret.Impuesto) {
                            case '001': RetencionISR += parseFloat(ret.Importe || 0); break;
                            case '002': RetencionIVA += parseFloat(ret.Importe || 0); break;
                            case '003': RetencionIEPS += parseFloat(ret.Importe || 0); break;
                        }
                    });
                } else if (retenciones) {
                    switch (retenciones.Impuesto) {
                        case '001': RetencionISR += parseFloat(retenciones.Importe || 0); break;
                        case '002': RetencionIVA += parseFloat(retenciones.Importe || 0); break;
                        case '003': RetencionIEPS += parseFloat(retenciones.Importe || 0); break;
                    }
                }

                // Formateo de los valores a formato con comas y puntos
                let formattedTotal = formatNumberMX(total);
                let formattedSubtotal = formatNumberMX(subtotal);
                let formattedTraslados = traslados ? formatNumberMX(traslados2) : null;
                let formattedTasaOCuota = formatNumberMX(tasaOCuota);
                let formattedDescuento = descuento > 0 ? formatNumberMX(descuento) : null;
                let formattedRetenidos = retenidos ? formatNumberMX(retenidos) : null;
                // Almacenar los valores formateados
                setTotal({
                    dTotal: formattedTotal,
                    dSubtotal: formattedSubtotal,
                    dtrasladosImpuestos: formattedTraslados,
                    TasaOCuota: formattedTasaOCuota,
                    Descuento: formattedDescuento,
                    Retenidos: formattedRetenidos,
                    RetencionIVA: RetencionIVA ? formatNumberMX(RetencionIVA) : null,
                    RetencionISR: RetencionISR ? formatNumberMX(RetencionISR) : null,
                    RetencionIEPS: RetencionIEPS ? formatNumberMX(RetencionIEPS) : null,
                    TrasladoIVA: TrasladoIVA ? formatNumberMX(TrasladoIVA) : null,
                    TrasladoISR: TrasladoISR ? formatNumberMX(TrasladoISR) : null
                });

                // cuando parseas y extraes del XML:
                setFacturaElectronica({
                    TipoDeComprobante: comprobante.TipoDeComprobante === "I"
                        ? 'I - Ingreso'
                        : comprobante.TipoDeComprobante === "E"
                            ? 'E - Egreso'
                            : 'P - Pago',
                    MetodoPago: comprobante.MetodoPago === "PUE" ? 'PUE - Pago en una sola exhibición' : 'PDD - Pago en parcialidades ',
                    FormaPago: ObjDetalles.table2[0].vClave,
                    Moneda: comprobante.Moneda,
                    LugarExpedicion: comprobante.LugarExpedicion,
                    Fecha: comprobante.Fecha,
                    Exportacion: comprobante.Exportacion === "01" ? '01 - No Aplica' : '',
                    CertificadoEmisor: comprobante.NoCertificado,
                    Serie: comprobante.Serie,
                    Folio: comprobante.Folio,
                    TipoDeCambio: comprobante.TipoCambio,
                    CondicionesDePago: comprobante.CondicionesDePago

                });





                setReceptor({
                    ...vXML.Comprobante.Receptor,
                    vUsoCFDI: ObjDetalles.table2[0].vUsoCfdi,
                    vRegimen: ObjDetalles.table2[0].vRegimenFiscal,
                    NumRegIdTrib: comprobante.Receptor.NumRegIdTrib,
                    ResidenciaFiscal: comprobante.Receptor.ResidenciaFiscal,
                    DomicilioFiscal: comprobante.Receptor.DomicilioFiscalReceptor

                });



                // cuando parseas y extraes del XML:
                setDatosSellos({
                    FechaTimbrado: complemento.FechaTimbrado,
                    NoCertificadoSAT: complemento.NoCertificadoSAT,
                    RfcProvCertif: complemento.RfcProvCertif,
                    SelloCFD: complemento.SelloCFD,
                    SelloSAT: complemento.SelloSAT,
                    UUID: complemento.UUID,
                    version: complemento.version,
                    certificacionSat: cadenaOriginal
                });



                let last8 = complemento.SelloCFD.slice(-8);

                setValue(`https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id=${complemento.UUID}&re=${emisorA.Rfc}&rr=${receptor.Rfc}&tt=${total}&fe=${last8}`);





            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";

            }
            setCargando(false)

        }
    };



    const handleOpenModal = (action) => {
        setCurrentAction(action);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentAction(null);
    };


    const handleConfirmAction = async () => {
        try {
            if (currentAction === 'eliminar') {
                await eliminarFactura();
            } else if (currentAction === 'cancelar') {
                await cancelarFactura();
            }
        } catch (error) {
            console.error(`Error al ${currentAction} la factura:`, error);
        }
    };

    const eliminarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        const response = await fetch("/api/FacturasRecibidas/EliminaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });



        if (response.ok) {
            setCargando(false);
            const data = await response.json();

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                setTimeout(() => {
                    location.href = "/contabilidad/facturacion/facturas-recibidas";
                }, 3000);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const cancelarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        const response = await fetch("/api/FacturasRecibidas/CancelaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    body: JSON.stringify(objDataSend)
                },
                body: JSON.stringify(objDataSend)

            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            setCargando(false);
            const data = await response.json();

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                setIsActive(false);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const handleOpenGastoModal = () => {
        setShowGastoModal(true);
    };

    const handleCloseGastoModal = () => {
        setShowGastoModal(false);
    };

    const handleGastoSuccess = (mensaje) => {
        showSuccessToast(mensaje);
        ObtenerXML();
    };

    const handleGastoError = (mensaje) => {
        showErrorToast(mensaje);
    };


    return (
        <>
            <Card>
                <Container className="py-4">
                    <HeaderFacturaRecibida
                        isActive={isActive}
                        idFactura={parseInt(id)}
                        vUUIDFactura={datosSellos.UUID}
                        dFechaEmision={facturaElectronica.Fecha}
                        vRfcEmisor={receptor.Rfc}
                    />
                    <ConsultarEstatus
                        uuid={datosSellos.UUID}
                        rfcEmisor={emisor?.Rfc}
                        rfcReceptor={receptor?.Rfc}
                        total={total.dTotal}
                    />
                    <DatosFactura
                        emisor={emisor}
                        receptor={receptor}
                        facturaElectronica={facturaElectronica}
                    />

                    <CondicionesPago facturaElectronica={facturaElectronica} />

                    <ConceptosFactura
                        conceptos={conceptos}
                        total={total}
                        facturaElectronica={facturaElectronica}
                    />

                    <SellosDigitales
                        datosSellos={datosSellos}
                        value={value}
                    />

                    <BotonesAccionRecibidas
                        TipoDeComprobante={facturaElectronica.TipoDeComprobante}
                        isActive={isActive}
                        handleOpenModal={handleOpenModal}
                        handleOpenGastoModal={handleOpenGastoModal}
                        idGasto={idGasto}
                    />
                </Container>
            </Card>

            <ConfirmationModal
                show={showModal}
                onHide={handleCloseModal}
                onConfirm={handleConfirmAction}
                action={currentAction}
                IsActive={isActive}
            />

            <ModalRegistrarFacturaComoGasto
                show={showGastoModal}
                onHide={handleCloseGastoModal}
                idFacturaRecibida={id}
                onSuccess={handleGastoSuccess}
                onError={handleGastoError}
            />

            {cargando && (
                <h6>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h6>
            )}
        </>
    );
}



export default VisualizacionFacturasRecibidas;